import { TId } from '@app/lib/type';
import { createAction } from '@reduxjs/toolkit';
import { features, createJob } from '../config';
import { TTestLineStatus, ITestNGPStatementGrading } from './types';
export { selectors } from '../config';

export const feature = features.testNGP;

export const jobs = {
  loadTestSettings: createJob.loadTestSettings(),
};

export const testName = 'Genus: NGP I';

interface IStatusActionPayload {
  payload: {
    testLineId: TId;
    status: TTestLineStatus;
  };
}

export const actions = {
  gotoEnterStatements: () => features.enterStatements.routeAction({}),
  gotoTestSVO: () => features.testSVO.routeAction({}),
  gotoTestNGP: () => features.testNGP.routeAction({}),
  gotoTestNominativ: () => features.testNominativ.routeAction({}),
  gotoTestNarration: () => features.testNarration.routeAction({}),
  gotoResultSummary: () => features.resultsSummary.routeAction({}),
  updateGrading: createAction(
    'UPDATE-GRADING@TEST-NGP',
    (testLineId: TId, update: Partial<ITestNGPStatementGrading>) => ({
      payload: { testLineId, update },
    })
  ),
  openGrading: createAction(
    'OPEN-GRADING@TEST-NGP',
    (testLineId: TId): IStatusActionPayload => ({
      payload: { testLineId, status: 'open' },
    })
  ),
};
